import { Logger } from "@rogoag/shared-ts";
import { IS_DEV_SENTRY, IS_PROD, DEBUG, IS_DEV } from "../../../utilities/constants";

export const logger = new Logger({
	application: "Portal Web",
	entrypoint: "logger.ts",
	isProduction: IS_PROD || IS_DEV_SENTRY,
	enableConsoleLogging: IS_DEV,
	verboseConsole: DEBUG,
	enableSentryLogging: IS_PROD || IS_DEV_SENTRY,
});

if (DEBUG) logger.log("Logger initialized");
